module.exports = __webpack_public_path__ + "img/qy (52).68fe227e.jpg";